import {
    deviceTypesFulfilledConstants,
    deviceTypesRejectedConstants,
    deviceTypesPendingConstants
} from '../actions';

const initialState = {
    data: [],
    error: '',
    loading: true
};

export default function (state = initialState, action) {
    switch (action.type) {
        case deviceTypesPendingConstants.DEVICETYPES_LOADED:
            return initialState;

        case deviceTypesFulfilledConstants.DEVICETYPES_LOADED:
            return {
                ...initialState,
                data: [].concat(action.payload).sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                }),
                loading: false
            };

        case deviceTypesFulfilledConstants.DEVICETYPE_CREATED:
            return { ...initialState,
                loading: false,
                data: [...state.data, action.payload] };

        case deviceTypesFulfilledConstants.DEVICETYPE_UPDATED:
            return { ...state,
                loading: false,
                data: state.data.map(c => (c.id === action.payload.id ? action.payload : c)) };

        case deviceTypesPendingConstants.DEVICETYPE_CREATED:
        case deviceTypesPendingConstants.DEVICETYPE_UPDATED:
            return { ...state, loading: true };

        case deviceTypesFulfilledConstants.DEVICETYPE_DELETED:
            return { ...state, data: state.data.filter(c => c.id !== action.payload) };

        case deviceTypesRejectedConstants.DEVICETYPE_CREATED:
        case deviceTypesRejectedConstants.DEVICETYPE_UPDATED:
        case deviceTypesRejectedConstants.DEVICETYPE_DELETED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        default:
            return state;
    }
}
